/**
 * 学习乐园 · 猜数字 1A2B（game-caishuzi.js）
 * ============================================================
 * 「逻辑与推理」组第三作：机器在心里写一串不重复的数字，你猜。
 *   xA = 有 x 个数字，数字对、位置也对；
 *   yB = 有 y 个数字，数字对、但位置不对。
 * 逻辑启蒙的经典：每一条反馈都是真信息，会推理的人用排除法逼近答案。
 *
 * 反馈底线（同本栏目所有游戏）：
 *   每条反馈不止给 xAyB，还把 A/B 的含义讲一遍（第一次玩不用翻 FAQ）；
 *   输入不合法讲原因（位数不够 / 有重复数字 / 混进了非数字）；
 *   放弃如实给你答案并记一次放弃，不进成绩。
 *
 * 口径（页面与 doc 页同步说明）：
 *   - 位数档 3/4/5，默认 4 位；答案 0–9 不重复，0 可以开头（如 0123 合法）；
 *   - 成绩按档存本机：最少猜测次数与完成局数；
 *   - 不计时排名：这游戏考的是推理深度不是手速，HUD 只记次数。
 *
 * 简化红线：不做中断续局，刷新即重开；成绩只存本机 localStorage，不上传。
 *
 * 冒烟钩子：window.STGuess 暴露纯引擎函数（judge / makeSecret / validate），
 * 供确定性用例；交互路径由 scripts/smoke-study.mjs 的对应 section 覆盖。
 */
(function (global) {
  'use strict';

  var PREF_KEY = 'study-caishuzi';
  var RECORD_KEY = 'study-caishuzi-record';

  /* ============ 纯引擎（无 DOM） ============ */

  /** 生成 N 位不重复数字（0–9，0 可开头），返回数组 */
  function makeSecret(n) {
    var pool = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    for (var j = pool.length - 1; j > 0; j--) {
      var k = Math.floor(Math.random() * (j + 1));
      var t = pool[j]; pool[j] = pool[k]; pool[k] = t;
    }
    return pool.slice(0, n);
  }

  /** 判定：A = 数字对位置对，B = 数字对位置不对（经典口径） */
  function judge(secret, guess) {
    var a = 0, b = 0;
    for (var i = 0; i < secret.length; i++) {
      if (guess[i] === secret[i]) a++;
      else if (secret.indexOf(guess[i]) >= 0) b++;
    }
    return { a: a, b: b };
  }

  /** 输入校验：不合法时 why 是给用户看的解释（字符级，不是报错） */
  function validate(text, n) {
    var s = String(text == null ? '' : text).replace(/\s+/g, '');
    if (!s.length) return { ok: false, why: '先输入 ' + n + ' 个数字。' };
    if (!/^\d+$/.test(s)) {
      var bad = s.match(/[^\d]/)[0];
      return { ok: false, why: '「' + bad + '」不是数字——只能填 0 到 9。' };
    }
    if (s.length !== n) return { ok: false, why: '要猜 ' + n + ' 位，你现在写了 ' + s.length + ' 位。' };
    var seen = {};
    for (var i = 0; i < s.length; i++) {
      if (seen[s[i]]) return { ok: false, why: '有重复数字：「' + s[i] + '」出现了两次。答案里的数字互不重复，你的猜测也是。' };
      seen[s[i]] = 1;
    }
    return { ok: true, guess: s.split('').map(Number), why: '' };
  }

  /* ============ 状态与工具 ============ */

  var root = null;
  var ui = {};
  var S = {
    n: 3, secret: [], history: [], guesses: 0, done: false,
    soundOn: true, resetArm: false, resetTimer: null,
  };

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* —— 音效（WebAudio 本地合成，与连连看/排排序同一套音色思路）—— */
  /* 手机外放响度补偿（口径统一，由 scripts/boost-sfx-mobile.mjs 批量写入）：
     手机小喇叭对 500Hz 以下钝感、超短音感知响度低——触屏设备把提示音增益翻倍、
     低于 500Hz 的音移高八度、衰减拉长；桌面/耳机维持原响度。 */
  var SFX_MOBILE = false;
  try {
    SFX_MOBILE = (global.matchMedia && global.matchMedia('(pointer: coarse)').matches) ||
      (global.navigator && global.navigator.maxTouchPoints > 0);
  } catch (e) { /* 检测不可用按桌面处理 */ }
  var actx = null;
  function sfx(kind) {
    if (!S.soundOn) return;
    try {
      var AC = global.AudioContext || global.webkitAudioContext;
      if (!AC) return;
      if (!actx) actx = new AC();
      if (actx.state === 'suspended' && actx.resume) actx.resume();
      var t = actx.currentTime;
      var seq;
      if (kind === 'ok') seq = [[700, 0]];
      else if (kind === 'bad') seq = [[210, 0]];
      else seq = [[523, 0], [659, 0.09], [784, 0.18]];   /* win：三连琶音 */
      var type = kind === 'bad' ? 'square' : 'sine';
      for (var i = 0; i < seq.length; i++) {
        var osc = actx.createOscillator();
        var g = actx.createGain();
        osc.type = type;
        osc.frequency.value = SFX_MOBILE && seq[i][0] < 500 ? seq[i][0] * 2 : seq[i][0];
        var t0 = t + seq[i][1];
        g.gain.setValueAtTime(0.0001, t0);
        g.gain.exponentialRampToValueAtTime(SFX_MOBILE ? 0.27 : 0.09, t0 + 0.012);
        g.gain.exponentialRampToValueAtTime(0.0001, t0 + (kind === 'win' && i === seq.length - 1 ? (SFX_MOBILE ? 0.32 : 0.24) : (SFX_MOBILE ? 0.16 : 0.1)));
        osc.connect(g).connect(actx.destination);
        osc.start(t0); osc.stop(t0 + (SFX_MOBILE ? 0.4 : 0.3));
      }
    } catch (e) { /* 音频不可用静默 */ }
  }

  /* —— 偏好与成绩（只存本机）—— */
  function save() {
    try { localStorage.setItem(PREF_KEY, JSON.stringify({ v: 1, n: S.n, soundOn: S.soundOn })); }
    catch (e) { /* 存储不可用静默（无痕模式） */ }
  }
  function restorePrefs() {
    try {
      var d = JSON.parse(localStorage.getItem(PREF_KEY) || '{}');
      if (d && d.v === 1) {
        if (d.n === 3 || d.n === 4 || d.n === 5) S.n = d.n;
        S.soundOn = d.soundOn !== false;
      }
    } catch (e) { /* 忽略脏数据 */ }
  }
  function loadRecord() {
    try { return JSON.parse(localStorage.getItem(RECORD_KEY) || '{}') || {}; }
    catch (e) { return {}; }
  }
  function saveRecord(rec) {
    try { localStorage.setItem(RECORD_KEY, JSON.stringify(rec)); } catch (e) { /* 静默 */ }
  }

  /** 反馈讲解：不止 xAyB，把含义说一遍（规则内嵌，不要求先读 FAQ） */
  function explain(r) {
    var head = r.a + 'A' + r.b + 'B——';
    if (r.a === 0 && r.b === 0) return head + '你猜的数字一个都不在答案里，这几个数字可以从候选里划掉了。';
    if (r.a === 0) return head + r.b + ' 个数字在答案里，但位置全不对——换个位置试试。';
    if (r.b === 0) return head + r.a + ' 个数字不但对了，位置也对——保留它们别动。';
    return head + r.a + ' 个数字位置也对，另有 ' + r.b + ' 个数字对了但位置不对。';
  }

  /* ============ 渲染 ============ */

  function renderStatus() {
    if (S.done) return;
    ui.status.textContent = '已猜 ' + S.guesses + ' 次'
      + (S.history.length ? ' · 最新 ' + S.history[S.history.length - 1].guess + ' → '
        + S.history[S.history.length - 1].a + 'A' + S.history[S.history.length - 1].b + 'B' : '');
  }

  function renderHistory() {
    ui.history.textContent = '';
    /* 最新在上，方便对照上一条反馈 */
    for (var i = S.history.length - 1; i >= 0; i--) {
      var h = S.history[i];
      var row = el('li', 'st-cs-row' + (h.win ? ' is-win' : ''));
      var txt = el('span', 'st-cs-guess', '#' + h.no + '　' + h.guess);
      var fb = el('span', 'st-cs-fb', h.a + 'A' + h.b + 'B');
      row.appendChild(txt);
      row.appendChild(fb);
      row.appendChild(el('span', 'st-cs-note', h.note));
      ui.history.appendChild(row);
    }
    ui.historyWrap.hidden = S.history.length === 0;
  }

  function recordStat(label, value) {
    var d = el('div', 'st-llk-stat');
    d.appendChild(el('span', 'st-llk-stat-label', label));
    d.appendChild(el('strong', 'st-llk-stat-value', value));
    return d;
  }

  function renderRecord() {
    var box = ui.record;
    box.textContent = '';
    var rec = loadRecord();
    var any = rec[3] && rec[3].best != null || rec[4] && rec[4].best != null || rec[5] && rec[5].best != null;
    if (!any) {
      box.className = 'st-llk-record is-empty';
      box.appendChild(el('p', 'st-llk-record-empty', '还没猜中过——猜中一局，这里按位数记下你的最少次数。'));
      return;
    }
    box.className = 'st-llk-record';
    [3, 4, 5].forEach(function (lv) {
      var r = rec[lv];
      box.appendChild(recordStat(lv + ' 位最少', r && r.best != null ? r.best + ' 次' : '—'));
    });
  }

  function renderButtons() {
    ui.resetBtn.classList.toggle('is-arm', S.resetArm);
    ui.resetBtn.textContent = S.resetArm ? '再点一次确认重置' : '重置成绩';
    ui.submitBtn.disabled = S.done;
    ui.input.disabled = S.done;
  }

  function renderLevels() {
    ui.levels.textContent = '';
    [3, 4, 5].forEach(function (lv) {
      var b = el('button', 'st-llk-pack-btn' + (S.n === lv ? ' is-active' : ''));
      b.type = 'button';
      b.setAttribute('data-level', String(lv));
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', S.n === lv ? 'true' : 'false');
      b.textContent = lv + ' 位数';
      b.addEventListener('click', function () {
        if (S.n === lv) return;
        S.n = lv;
        renderLevels();
        newGame();
        save();
      });
      ui.levels.appendChild(b);
    });
  }

  function renderNote(msg, tone) {
    ui.note.textContent = msg;
    ui.note.className = 'st-llk-note' + (tone ? ' is-' + tone : '');
  }

  /* ============ 交互 ============ */

  function submit() {
    if (S.done) return;
    var v = validate(ui.input.value, S.n);
    if (!v.ok) {
      renderNote(v.why, 'warn');
      sfx('bad');
      return;
    }
    S.guesses++;
    var r = judge(S.secret, v.guess);
    S.history.push({ no: S.guesses, guess: v.guess.join(''), a: r.a, b: r.b, note: explain(r) });
    if (r.a === S.n) { finish(v.guess); return; }
    renderNote(explain(r) + ' 结合之前每一条，划掉不可能的，缩小范围再猜。', '');
    ui.input.value = '';
    sfx('ok');
    renderHistory();
    renderStatus();
  }

  function finish(guess) {
    S.done = true;
    var rec = loadRecord();
    var r = rec[S.n] || { best: null, plays: 0 };
    r.plays++;
    var isBest = r.best == null || S.guesses < r.best;
    if (isBest) r.best = S.guesses;
    rec[S.n] = r;
    saveRecord(rec);
    ui.status.textContent = '猜中了！答案就是 ' + guess.join('') + '，共猜 ' + S.guesses + ' 次';
    ui.status.className = 'st-status is-over';
    renderNote('用了 ' + S.guesses + ' 次猜测'
      + (isBest ? '——这是 ' + S.n + ' 位数档的最好成绩！' : '，这个档位你最少 ' + r.best + ' 次猜中过。')
      + '每条反馈都是真信息：会玩的人不是猜得准，是划得狠。', 'ok');
    renderHistory();
    renderRecord();
    renderButtons();
  }

  function giveUp() {
    if (S.done) return;
    if (!S.history.length) {
      renderNote('还没猜过呢，先试一次。', '');
      return;
    }
    S.done = true;
    ui.status.textContent = '已放弃 · 答案是 ' + S.secret.join('');
    ui.status.className = 'st-status is-over';
    renderNote('答案是 ' + S.secret.join('') + '。放弃这一局如实记录（不进成绩）：回看你的猜测列表，'
      + '想想哪几条反馈本可以把范围缩得更小——复盘比再来一局有用。', 'warn');
    renderHistory();
    renderButtons();
  }

  function newGame() {
    S.secret = makeSecret(S.n);
    S.history = [];
    S.guesses = 0;
    S.done = false;
    ui.status.className = 'st-status';
    ui.status.textContent = '已猜 0 次';
    renderNote(S.n + ' 位不重复数字（0 可以开头）。每条反馈都是真信息，用排除法逼近。', '');
    ui.input.value = '';
    ui.input.placeholder = S.n + ' 位不重复数字，如 0123';
    ui.input.maxLength = S.n;
    ui.input.setAttribute('inputmode', 'numeric');
    ui.input.setAttribute('autocomplete', 'off');
    renderHistory();
    renderButtons();
  }

  /* ============ boot ============ */

  function boot() {
    root = document.querySelector('[data-st-game]');
    if (!root) return;
    ui.status = root.querySelector('[data-st-status]');
    ui.note = root.querySelector('[data-st-note]');
    ui.levels = root.querySelector('[data-st-cs-levels]');
    ui.history = root.querySelector('[data-st-cs-history]');
    ui.historyWrap = root.querySelector('[data-st-cs-history-wrap]');
    ui.record = root.querySelector('[data-st-record]');
    ui.input = root.querySelector('[data-st-cs-input]');
    ui.submitBtn = root.querySelector('[data-st-cs-submit]');
    ui.giveupBtn = root.querySelector('[data-st-cs-giveup]');
    ui.newBtn = root.querySelector('[data-st-new]');
    ui.resetBtn = root.querySelector('[data-st-reset]');
    if (!ui.input) return;

    restorePrefs();
    renderLevels();
    bindSoundPicker();

    ui.submitBtn.addEventListener('click', submit);
    ui.input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submit(); } });
    ui.giveupBtn.addEventListener('click', giveUp);
    ui.newBtn.addEventListener('click', function () { newGame(); });
    ui.resetBtn.addEventListener('click', resetRecord);

    newGame();
  }

  function resetRecord() {
    if (!S.resetArm) {
      S.resetArm = true;
      renderButtons();
      if (S.resetTimer) clearTimeout(S.resetTimer);
      S.resetTimer = setTimeout(function () { S.resetArm = false; S.resetTimer = null; renderButtons(); }, 3000);
      return;
    }
    S.resetArm = false;
    if (S.resetTimer) { clearTimeout(S.resetTimer); S.resetTimer = null; }
    saveRecord({});
    renderRecord();
    renderButtons();
    renderNote('已重置猜数字的本机成绩。', '');
  }

  /* 音效选择器（口径同排排序：tool-segmented 双按钮） */
  function bindSoundPicker() {
    var btns = root.querySelectorAll('[data-st-sound]');
    for (var i = 0; i < btns.length; i++) {
      (function (b) {
        b.addEventListener('click', function () {
          S.soundOn = b.getAttribute('data-st-sound') === 'on';
          syncSoundPicker();
          save();
          if (S.soundOn) sfx('ok');
        });
      })(btns[i]);
    }
    syncSoundPicker();
  }
  function syncSoundPicker() {
    var btns = root.querySelectorAll('[data-st-sound]');
    for (var i = 0; i < btns.length; i++) {
      var on = (btns[i].getAttribute('data-st-sound') === 'on') === S.soundOn;
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-checked', on ? 'true' : 'false');
    }
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }

  global.STGuess = {
    judge: judge,
    makeSecret: makeSecret,
    validate: validate,
    explain: explain,
  };
})(typeof window !== 'undefined' ? window : this);
